import { render } from "./NetScoreTable.vue?vue&type=template&id=089c5379&scoped=true"
import script from "./NetScoreTable.vue?vue&type=script&lang=js"
export * from "./NetScoreTable.vue?vue&type=script&lang=js"

import "./NetScoreTable.vue?vue&type=style&index=0&id=089c5379&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-089c5379"]])

export default __exports__